import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { BrnPopover } from '@spartan-ng/brain/popover';

/**
 * Helm popover component (spartan layer).
 * Wraps BrnPopover as a host directive and provides the `hlm-popover` selector.
 *
 * @example
 * <hlm-popover>
 *   <button hlmPopoverTrigger>Open</button>
 *   <hlm-popover-content *hlmPopoverPortal>...</hlm-popover-content>
 * </hlm-popover>
 */
@Component({
  selector: 'hlm-popover',
  standalone: true,
  hostDirectives: [
    {
      directive: BrnPopover,
      inputs: [
        'state',
        'closeOnOutsidePointerEvents',
        'closeOnBackdropClick',
        'align',
        'sideOffset',
        'offsetX',
        'attachTo',
      ],
      outputs: ['closed', 'stateChanged'],
    },
  ],
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HlmPopoverComponent {}
